<template>
  <div ref="popover" class="h-full w-full bg-transparent" popover>
    <Overlay v-if="loading" :text="loadingText" />
  </div>
</template>

<script setup lang="ts">
  const emit = defineEmits(["loading", "loaded"]);
  const popover = useTemplateRef("popover");
  const loading = ref(false);
  const loadingText = ref<string>();

  onMounted(() => {
    EventBus.$on("LOADER_OPEN", (text?: string) => {
      emit("loading", text);
      popover.value?.showPopover?.();
      loadingText.value = text;
      loading.value = true;
    });
    EventBus.$on("LOADER_CLOSE", (text?: string) => {
      emit("loaded", text);
      popover.value?.hidePopover?.();
      loadingText.value = text;
      loading.value = false;
    });
    EventBus.$on("LOADER_TOGGLE", (text?: string) => {
      if (!loading.value) {
        emit("loading", text);
        popover.value?.showPopover?.();
      } else {
        emit("loaded", text);
        popover.value?.hidePopover?.();
      }
      loadingText.value = text;
      loading.value = !loading.value;
    });
  });

  onUnmounted(() => {
    EventBus.$off("LOADER_OPEN");
    EventBus.$off("LOADER_CLOSE");
    EventBus.$off("LOADER_TOGGLE");
  });
</script>
